import atlas from 'azure-maps-control';
import React, { useContext } from 'react';
import { UserContext } from '../../../../../context/UserContext';
import {
  MobileStockLocationSession,
  MobileStockLocationSessionStatus,
} from '../../../../../types/mobile_stock_location';
import { StockLocation } from '../../../../../types/stock_location';
import Icon, { IconType } from '../../../../icons/Icon';
import { StockLocationMarker } from '../../markers/templates/StockLocationMarker';
import MapPopup from '../../popups/MapPopup';
import { ClusterLayer, ClusterProperties } from '../ClusterLayer';
import { MarkerLayer } from '../MarkerLayer';

export class StockLocationMarkerLayer extends MarkerLayer<StockLocationMarker> {
  constructor() {
    super();
  }

  markerBuilder = (stockLocation: StockLocation, session?: MobileStockLocationSession) => {
    return new StockLocationMarker(stockLocation, session);
  };

  popupBuilder = (marker: StockLocationMarker) => {
    return <StockLocationMarkerPop marker={marker} />;
  };
}

function StockLocationMarkerPop({ marker }: { marker: StockLocationMarker }) {
  const { companyUsers } = useContext(UserContext);
  const user =
    marker.session?.status === MobileStockLocationSessionStatus.active && companyUsers.get(marker.session.updatedBy);
  return (
    <MapPopup>
      <p className='text-sm font-medium'>{marker.stockLocation.name}</p>
      {user ? <p className='text-sm'>Driver: {user.email}</p> : null}
    </MapPopup>
  );
}

export class StockLocationClusterLayer extends ClusterLayer<StockLocationMarker> {
  get options(): atlas.SymbolLayerOptions {
    const s = super.options;
    return {
      ...s,
      textOptions: {
        ...s.textOptions,
        textField: ['get', 'point_count_abbreviated'], // Shows cluster count
      },
    };
  }

  popupBuilder = (props: ClusterProperties, markers: StockLocationMarker[]) => (
    <MapPopup>
      <p className='font-medium'>{markers.length} Stock locations</p>
      <ul>
        {markers.map(m => (
          <li key={m.id} className='flex items-center gap-2'>
            <Icon
              type={m.stockLocation.mobile ? IconType.truck1 : IconType.building3}
              stroke={
                m.session?.status === MobileStockLocationSessionStatus.active ? 'stroke-success-500' : 'stroke-subtitle'
              }
            />
            <p>{m.stockLocation.name}</p>
          </li>
        ))}
      </ul>
    </MapPopup>
  );
}
